import React from 'react';
import AttendanceManagement from './AttendanceManagement';
import { useTranslation } from 'react-i18next';

const Attendance: React.FC = () => {
  const { t } = useTranslation('attendance');
  return (
    <section className="px-4 py-3 space-y-5">
      <h6 className="font-bold text-title">{t('title')}</h6>
      <div className="bg-white rounded-md p-4">
        <AttendanceManagement />
      </div>
    </section>
  );
};

export default Attendance;
